import React, { useContext, useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import About from "../pages/About";
import RedeemCodes from "../pages/RedeemCodes";
import Message from "./Message";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { themeSwitcherContext } from "./../context/themeContext";
import IconButton from "@mui/material/IconButton";
import TwitterIcon from "@mui/icons-material/Twitter";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

const Navbar = () => {
  const themeSwitcher = useContext(themeSwitcherContext);

  const [message, setMessage] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        `https://revived-witch-api.herokuapp.com/message`
      );
      res.json().then((res) => setMessage(res.message[0]));
    };

    fetchData();
  }, []);

  return (
    <>
      <Toolbar sx={{ borderBottom: 1, borderColor: "divider" }}>
        <About />
        <Link
          rel="noopener noreferrer"
          href="https://twitter.com/Ismael9813"
          target="_blank"
        >
          <IconButton variant="contained">
            <TwitterIcon />
          </IconButton>
        </Link>
        <Typography
          component="h2"
          variant="h5"
          color="inherit"
          align="center"
          noWrap
          sx={{ marginTop: 1, flex: 1 }}
        >
          <img
            alt="logo"
            src="rw-android-icon-192x192.png"
            style={{ width: 60, height: 60, borderRadius: 10 }}
          />
        </Typography>
        <IconButton
          variant="contained"
          onClick={() => themeSwitcher.setearThema("dark")}
        >
          <DarkModeIcon />
        </IconButton>
        <IconButton
          variant="contained"
          onClick={() => themeSwitcher.setearThema("light")}
        >
          <Brightness7Icon />
        </IconButton>
      </Toolbar>
      <Toolbar
        component="nav"
        variant="regular"
        sx={{ justifyContent: "space-between", overflowX: "auto" }}
      >
        <Stack
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
          spacing={2}
        >
          <Button
            variant="contained"
            component={RouterLink}
            to="/home"
            style={{ borderRadius: 30 }}
          >
            Home
          </Button>
          <Button
            variant="contained"
            component={RouterLink}
            to="/"
            style={{ borderRadius: 30 }}
          >
            Dolls
          </Button>

          <Button
            variant="contained"
            component={RouterLink}
            to="/enemies"
            style={{ borderRadius: 30 }}
          >
            Enemies
          </Button>
          <Button
            variant="contained"
            component={RouterLink}
            to="/equipments-list"
            style={{ borderRadius: 30 }}
          >
            Equipments
          </Button>
          <Button
            variant="contained"
            component={RouterLink}
            to="/exweapons-list"
            style={{ borderRadius: 30 }}
          >
            EXWeapons
          </Button>
          <Button
            variant="contained"
            component={RouterLink}
            to="/events-list"
            style={{ borderRadius: 30 }}
          >
            Events
          </Button>

          <Button
            variant="contained"
            component={RouterLink}
            to="/story"
            style={{ borderRadius: 30 }}
          >
            MainStory
          </Button>

          <Button
            variant="contained"
            component={RouterLink}
            to="/upchar-list"
            style={{ borderRadius: 30 }}
          >
            UpcomingDolls
          </Button>
          <Button
            variant="contained"
            component={RouterLink}
            to="/items"
            style={{ borderRadius: 30 }}
          >
            Items
          </Button>
          <Button
            variant="contained"
            component={RouterLink}
            to="/gifts-list"
            style={{ borderRadius: 30 }}
          >
            Gifts
          </Button>
          <Button
            variant="contained"
            component={RouterLink}
            to="/frames-list"
            style={{ borderRadius: 30 }}
          >
            Avatars
          </Button>

          <RedeemCodes />
        </Stack>
      </Toolbar>
      <Message
        title={message.title}
        message={message.message}
        severity={message.severity}
      />
    </>
  );
};

export default Navbar;
